import React from "react";

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h1>
        <p className="text-gray-700 mb-6">
          Have questions or feedback?<br />
          Just click below to email us.
        </p>
        <a
          href="mailto:admin@ratewho.com"
          className="inline-block px-6 py-3 rounded-xl bg-primary-600 hover:bg-primary-700 text-white font-semibold transition"
        >
          Email admin@ratewho.com
        </a>
      </div>
    </div>
  );
};

export default Contact;
